var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('ul',{staticClass:"list-unstyled"},_vm._l((_vm.list),function(item){return _c('li',{key:item.index},[_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.capitilize(item)))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }